export const SEVENROOMS_SOURCE_FIELDS = [
  { source: "first_name", label: "First name" },
  { source: "last_name", label: "Last name" },
  { source: "phone_number", label: "Phone number" },
  { source: "dob", label: "Date of birth" },
  { source: "gender", label: "Gender" },
];

export const DEFAULT_SEVENROOMS_FIELD_MAPPINGS = {
  first_name: "first_name",
  last_name: "last_name",
  phone_number: "phone_number",
  dob: "birthday",
  gender: "gender",
};

export const SEVENROOMS_CLIENT_FIELDS = [
  { name: "first_name", label: "First name" },
  { name: "last_name", label: "Last name" },
  { name: "phone_number", label: "Phone number" },
  { name: "birthday", label: "Birthday" },
  { name: "gender", label: "Gender" },
];

const WRITABLE_FIELD_NAMES = new Set(SEVENROOMS_CLIENT_FIELDS.map((field) => field.name));

export function normalizeSevenRoomsFieldMappings(value) {
  const incoming = value && typeof value === "object" ? value : {};
  const normalized = {};
  SEVENROOMS_SOURCE_FIELDS.forEach(({ source }) => {
    const mapped = String(incoming[source] || "").trim();
    normalized[source] = WRITABLE_FIELD_NAMES.has(mapped)
      ? mapped
      : DEFAULT_SEVENROOMS_FIELD_MAPPINGS[source];
  });
  return normalized;
}

export function sevenRoomsFieldLabel(name) {
  return SEVENROOMS_CLIENT_FIELDS.find((field) => field.name === name)?.label || name;
}
